import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { ReportTemplateGetFieldsByTemplateId, ReportTemplateGetFieldsByTemplateIdResponse } from '../../api/dtos';

const getData = (response?: SWRResponse<ReportTemplateGetFieldsByTemplateIdResponse, ReportTemplateGetFieldsByTemplateIdResponse>) => {
    return response?.data?.fields;
}
const getError = (response?: SWRResponse<ReportTemplateGetFieldsByTemplateIdResponse, ReportTemplateGetFieldsByTemplateIdResponse>) => (response?.error ?? response?.data)?.responseStatus;
// const getAdditionalState = (response?: SWRResponse<StageGetSummaryCollectionByProjectIdResponse, StageGetSummaryCollectionByProjectIdResponse>) => ({});

const useReportTemplateFieldsByTemplateId = (templateId?: number, configuration?: SWRConfiguration<ReportTemplateGetFieldsByTemplateIdResponse, ReportTemplateGetFieldsByTemplateIdResponse>) => {
    const request = useMemo(() => {
        if(!templateId) return undefined;
        return () => {
            return new ReportTemplateGetFieldsByTemplateId({
                templateId: templateId
            });
        };
    }, [templateId])

    return useGet(request, { getData, getError }, configuration);
}

export default useReportTemplateFieldsByTemplateId;